module Meevo.Plugins.Teachers {
    "use strict";

    /**
    * OnlineBooking Section of Teachers
    */
    export class OnlineBookingSection extends Meevo.Plugins.Employee.OnlineBookingSection {

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            modalService: Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, modalService, sectionSecurityKey);

        }

    }
}